export const sendData = (objectDigitalData) => {
    window.digitalData = objectDigitalData;
     document.dispatchEvent(new CustomEvent('SPAPageTriggered'));
}